/**
 * BackButton — reusable back navigation button.
 *
 * Matches EXACTLY the design used by AdminGlobalAnalyticsPage:
 *  - shadcn `<Button variant="outline" size="sm">`
 *  - `ArrowLeft` icon (14px) with 1.5 right margin
 *  - label driven by i18n `common.back`
 *  - single-click navigation; `to` prop overrides the default (browser-back).
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';

export default function BackButton({
    to,
    label,
    className = '',
    'data-testid': testId = 'back-button',
    onClick,
}) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
            if (e.defaultPrevented) return;
        }
        if (to) {
            navigate(to);
        } else {
            navigate(-1);
        }
    };

    return (
        <Button
            variant="outline"
            size="sm"
            onClick={handleClick}
            className={className}
            data-testid={testId}
        >
            <ArrowLeft className="w-4 h-4 mr-1.5" />
            {label || t('common.back')}
        </Button>
    );
}
